import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService as Spinner } from '../../shared/components/spinner/spinner.service';
import { environment } from '../../../environments/environment';
import { ProfilePersonalDataService as ProfilePersonalData } from '../profile/profile-personal-data/profile-personal-data.service';

export interface AuthTokenResponse {
  token_type: string;
  expires_in: number;
  access_token: string;
  refresh_token: string;
  user_id: number;
  patient_id: number | null;
}
@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly API_URL = environment.apiUrl;

  private accessTokenSignal = signal<string | null>(localStorage.getItem('access_token'));


  private emailSignal = signal<string | null>(localStorage.getItem('user_email'));

  private userIdSignal = signal<string | null>(localStorage.getItem('user_id'));

  accessToken = this.accessTokenSignal.asReadonly();
  email = this.emailSignal.asReadonly();
  user_id = this.userIdSignal.asReadonly();

  constructor(
    private http: HttpClient,
    private spinner: Spinner,
    private profilePersonalData: ProfilePersonalData,
  ) {}

  login(email: string, password: string) {
    this.spinner.open({
      title: 'Iniciando sesión',
      message: 'Validando tus credenciales, por favor esperá.',
    });

    return this.http
      .post<AuthTokenResponse>(`${this.API_URL}/login`, {
        client_id: environment.auth.clientId,
        client_secret: environment.auth.clientSecret,
        user: email,
        password,
      })
      .pipe(
        tap((resp) => {
          localStorage.setItem('access_token', resp.access_token);
          localStorage.setItem('refresh_token', resp.refresh_token);
          localStorage.setItem('user_id', resp.user_id.toString());
          localStorage.setItem('user_email', email);
          this.accessTokenSignal.set(resp.access_token);
          this.emailSignal.set(email);
          this.userIdSignal.set(resp.user_id.toString());
          this.profilePersonalData.loadUserById(resp.user_id.toString());

        }),
        finalize(() => {
          this.spinner.close();
        }),
      );
  }

  logout() {
    localStorage.clear();
    this.accessTokenSignal.set(null);
    this.emailSignal.set(null);
    localStorage.removeItem('user_email');
    this.userIdSignal.set(null);
    localStorage.removeItem('user_id');
  }

  isLoggedIn(): boolean {
    return !!this.accessTokenSignal();
  }

  getToken(): string | null {
    return this.accessTokenSignal();
  }

  getEmail(): string | null {
    return this.emailSignal();
  }

  getUser_id(): string | null {
    return this.userIdSignal();
  }
}
